import { API } from "@/services"
import { UPTIME_KUMA_GROUPS_ENDPOINTS } from "./groups"

export const UPTIME_KUMA_CATEGORIES_ENDPOINTS = {
  groups: UPTIME_KUMA_GROUPS_ENDPOINTS,
  create(data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories`,
      method: 'POST',
      data,
    })
  },
  get(params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories`,
      method: 'GET',
      params,
    })
  },
  findById(id,params={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${id}`,
      method: 'GET',
      params,
    })
  },
  delete(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${id}`,
      method: 'DELETE',
      data,
    })
  },
  update(id='',data={}){
    return API.Axios.error_capture.v1.request({
      url: `uptime-kuma/categories/${id}`,
      method: 'PUT',
      data,
    })
  },
}